import { createTheme } from '@mui/material/styles';

const Default = createTheme({
  palette: {
    mode: 'dark',
    root: {
      color: "#FFFFFF"
    },
    primary: {
      main: '#46BF8C',
      dark: '#07A892',
      darker: '#009090',
    },
    danger: {
      main: '#EE0000',
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
  },
});

const CreateMuiTheme = (customColors) => {
  let colors = {
    palette: {
      mode: 'dark',
      root: {
        color: "#FFFFFF"
      },
      primary: {
        main: '#46BF8C',
        dark: '#07A892',
        darker: '#009090',
      },
      danger: {
        main: '#EE0000',
      },
      neutral: {
        main: '#64748B',
        contrastText: '#fff',
      },
    },
  }

  if (customColors) {
    if (customColors.hasOwnProperty('--live-call-color-mode')) colors.palette.mode = customColors['--live-call-color-mode'] 
    if (customColors.hasOwnProperty('--live-call-color-root-color')) colors.palette.root.color = customColors['--live-call-color-root-color'] 
    if (customColors.hasOwnProperty('--live-call-color-primary-main')) colors.palette.primary.main = customColors['--live-call-color-primary-main'] 
    if (customColors.hasOwnProperty('--live-call-color-primary-dark')) colors.palette.primary.dark = customColors['--live-call-color-primary-dark'] 
    if (customColors.hasOwnProperty('--live-call-color-primary-darker')) colors.palette.primary.darker = customColors['--live-call-color-primary-darker'] 
    if (customColors.hasOwnProperty('--live-call-color-danger-main')) colors.palette.danger.main = customColors['--live-call-color-danger-main'] 
    if (customColors.hasOwnProperty('--live-call-color-neutral-main')) colors.palette.neutral.main = customColors['--live-call-color-neutral-main'] 
    if (customColors.hasOwnProperty('--live-call-color-neutral-contrastText')) colors.palette.neutral.contrastText = customColors['--live-call-color-neutral-contrastText'] 
  }

  let theme = createTheme(colors)
  return theme
}

export default CreateMuiTheme;